import React from "react";
import { motion } from "framer-motion";
import CustomizableInterview from "../../../../assets/images/VIGenericScreen.png";
import ResponsiveSupport from "../../../../assets/images/vidinterviewer_customerservice.png";
import FlexiblePricing from "../../../../assets/images/VI_shakinghands.png";

import PropTypes from "prop-types";
const FeatureCard = ({ title, description, image, isEven, controls }) => {
  return (
    <motion.div
      className={`flex flex-col ${
        isEven ? "md:flex-row-reverse" : "md:flex-row"
      } items-center gap-8 mb-20`}
      initial={{ opacity: 0, x: isEven ? 50 : -50 }}
      animate={controls}
    >
      <div className="md:w-1/2">
        <img
          src={image}
          alt={title}
          className="w-[85%] h-auto rounded-lg shadow-lg mx-auto"
        />
      </div>
      <div className="md:w-1/2 font-sans">
        <h3 className="text-2xl md:text-3xl font-bold mb-4 text-ashGray">
          {title}
        </h3>
        <p className="text-lg text-ashGray">{description}</p>
      </div>
    </motion.div>
  );
};

const FeaturesSection = ({
  ref3,
  ref4,
  ref5,
  controls3,
  controls4,
  controls5,
}) => {
  return (
    <section className="py-20 px-4 bg-white">
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-ashGray font-sans">
          Why Choose VidInterviewer?
        </h2>
        <div className="w-24 h-1 bg-gradient-primary mx-auto mb-16 rounded-full"></div>

        <div ref={ref3}>
          <FeatureCard
            title="Customizable Interview Experiences"
            description="Create branded, personalized interview experiences that reflect your company culture. Customize questions, add video introductions, and tailor the experience to your specific needs."
            image={CustomizableInterview}
            isEven={true}
            controls={controls3}
          />
        </div>

        <div ref={ref4}>
          <FeatureCard
            title="Responsive Personalized Support"
            description="We're here to help you every step of the way. Our small team is local and available to answer your questions and provide assistance whenever you need it."
            image={ResponsiveSupport}
            isEven={false}
            controls={controls4}
          />
        </div>

        <div ref={ref5}>
          <FeatureCard
            title="Flexible Pricing"
            description="Our business's size gives us maneuverability, allowing us to offer a flexible pricing model, from a single interview to a subscription service. We also offer a free trial for all new users."
            image={FlexiblePricing}
            isEven={true}
            controls={controls5}
          />
        </div>
      </div>
    </section>
  );
};

FeaturesSection.propTypes = {
  ref3: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  ref4: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  ref5: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  controls3: PropTypes.object,
  controls4: PropTypes.object,
  controls5: PropTypes.object,
};

FeatureCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  isEven: PropTypes.bool.isRequired,
  controls: PropTypes.object.isRequired,
};

export default FeaturesSection;
